// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"20d24d8c","453":"50772734","732":"e86326ae"}[chunkId] + ".chunk.js";
};